import { render, staticRenderFns } from "./blacklist.vue?vue&type=template&id=8286d26a&scoped=true"
import script from "./blacklist.vue?vue&type=script&lang=js"
export * from "./blacklist.vue?vue&type=script&lang=js"
import style0 from "./blacklist.vue?vue&type=style&index=0&id=8286d26a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8286d26a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8286d26a')) {
      api.createRecord('8286d26a', component.options)
    } else {
      api.reload('8286d26a', component.options)
    }
    module.hot.accept("./blacklist.vue?vue&type=template&id=8286d26a&scoped=true", function () {
      api.rerender('8286d26a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ad/blacklist.vue"
export default component.exports